import { EstimateCost } from './estimate-cost.model';
import { EstimateMaterial } from './estimate-material.model';
import { EstimateOperation } from './estimate-operation.model';

export class Estimate {
  DiscountMaterial: number;
  DiscountOperation: number;
  DiscountOrder: number;
  PriceOrderWithDiscount: number;
  OrderVAT: number;

  PriceMaterial = 0;
  PriceOperation = 0;
  PriceOrder = 0;
  Materials: EstimateMaterial[];
  Operations: EstimateOperation[];
  AdditionalOperations: EstimateOperation[];
  Costs: EstimateCost[];

  constructor(est?: Estimate | any) {
    est = est || {};
    this.Materials = est.Materials || [];
    this.Operations = est.Operations || [];
    this.PriceOrder = est.PriceOrder || 0;
    this.PriceMaterial = est.PriceMaterial || 0;
    this.PriceOperation = est.PriceOperation || 0;
    this.AdditionalOperations = est.AdditionalOperations || [];
    this.Costs = est.Costs || [];
  }
}
